import { ref } from 'vue';

const MAX_MOBILE_WIDTH_PX = 1023;

export type ClientSize = 'mobile' | 'small' | 'medium' | 'large' | 'huge';

const isMobile = ref<boolean>(false);
const clientSize = ref<ClientSize>('medium');

function calculateIsMobile() {
  isMobile.value = window.innerWidth <= MAX_MOBILE_WIDTH_PX;
}

function calculateClientSize() {
  const windowWidth = window.document.documentElement.clientWidth;

  if (windowWidth <= 1023) {
    clientSize.value = 'mobile';
  } else if (windowWidth <= 1364) {
    clientSize.value = 'small';
  } else if (windowWidth <= 1599) {
    clientSize.value = 'medium';
  } else if (windowWidth <= 1919) {
    clientSize.value = 'large';
  } else {
    clientSize.value = 'huge';
  }
}

window.addEventListener('resize', () => {
  calculateIsMobile();
  calculateClientSize();
});

calculateIsMobile();
calculateClientSize();

export function useClientSize() {
  return {
    isMobile,
    clientSize
  };
}
